import "features/bulletins/assets/styles/BulletinTeaser.scss";
import UserDetail from "components/ui/UserDetail/UserDetail";
import Labels from "components/ui/Labels/Labels";
import Button from "components/ui/Button/Button";
import ResponsiveImage from "components/ui/ResponsiveImage/ResponsiveImage";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { useView } from "features/view/context/ViewContext";
import { useAccount } from "context/AccountContext";
import BulletinOwnerButtons from "features/bulletins/components/BulletinOwnerButtons";
import ButtonLike from "features/likes/components/ButtonLike/ButtonLike";
import { useState } from "react";
import ParticipationStatusBar from "components/ui/ParticipationStatusBar/ParticipationStatusBar";

function BulletinTeaser({
                          data,
                          teaserVariant,
                          labelVariant,
                          hideUserDetail,
                          hideEditButtons,
                          isMarketPlace
                        }) {
  const history = useHistory();
  const { user } = useAccount();
  const { refresh } = useView();
  const [ likeCount, setLikeCount ] = useState(0);

  const isOwner = user && parseInt(user.id) === parseInt(data.uid);
  let labels = [];
  labels.push(data.bulletin_type)

  if (data.location_distance) {
    labels.push(`${ data.location_distance > 1 ? Math.round(data.location_distance) : '< 1' } km`);
  }

  return (
    <div className={ `teaser ${ teaserVariant && 'teaser--' + teaserVariant }` }>
      <div className={ 'teaser__inner' }>
        <div className={ 'teaser__actions' }>
          <Labels items={ labels } variant={ labelVariant }/>

          <ButtonLike
            entityId={ parseInt(data.nid) }
            entityType={ `bulletin` }
            onReceivedCount={ (count) => setLikeCount(count) }
          />
        </div>

        <div className={ 'teaser__title' }>
          <h3 className={ 'pointer' } onClick={ () => history.push(data.url) }>{ data.title }</h3>
        </div>

        { !hideUserDetail &&
          <div className={ 'teaser__user' }>
            <UserDetail image={ data.field_profile_photo }
                        username={ data.field_profile_title }
                        subtext={ data.field_profile_city }/>
          </div>
        }

        <span>{ data.created }</span>

        {
          data.field_bulletin_image &&
          <div className={ 'teaser__image' }>
            <ResponsiveImage value={ data.field_bulletin_image }/>
          </div>
        }

        <div className={ 'teaser__intro' }>
          { data.field_description }
        </div>

        <div className={ 'teaser__buttons' }>
          <Button onClick={ () => history.push(data.url) } variant={ 'secondary' } className={ 'button--small' }>
            Bekijk bericht
          </Button>

          {
            isOwner && !hideEditButtons &&
            <BulletinOwnerButtons bulletinId={ parseInt(data.nid) }
                                  bulletinTitle={ data.title }
                                  isMarketPlace={ isMarketPlace }
                                  categoryId={ parseInt(data.parent_type_id) }
                                  onDeleted={ refresh }
                                  onEdited={ refresh }/>
          }
        </div>

        <ParticipationStatusBar
          commentCount={ Number(data.comment_count) }
          likeCount={ likeCount }
          variant={ `teaser` }
        />
      </div>
    </div>
  );
}

BulletinTeaser.defaultProps = {
  teaserVariant: '',
  labelVariant: 'dark',
  buttonVariant: 'light',
  hideUserDetail: false,
  hideEditButtons: false,
  isMarketPlace: false,
}

BulletinTeaser.propTypes = {
  teaserVariant: PropTypes.string,
  labelVariant: PropTypes.string,
  buttonVariant: PropTypes.string,
  hideUserDetail: PropTypes.bool,
  hideEditButtons: PropTypes.bool,
  isMarketPlace: PropTypes.bool,
}

export default BulletinTeaser;
